import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Gate around /admin/* routes. A platform admin who is NOT impersonating
 * gets through; everyone else gets bounced to the tenant dashboard. We
 * deliberately mirror what the backend enforces (require_platform_admin)
 * so the client never even renders admin chrome it cannot use.
 */
export function PlatformAdminRoute({ children }) {
    const { user, loading } = useAuth();
    const loc = useLocation();

    if (loading) {
        return (
            <div
                data-testid="admin-auth-loading"
                className="grid min-h-screen place-items-center bg-background text-zinc-500"
            >
                <div className="flex items-center gap-3">
                    <div className="h-2 w-2 animate-pulse rounded-full bg-brand-red" />
                    <span className="font-mono text-xs uppercase tracking-wider">Loading admin…</span>
                </div>
            </div>
        );
    }

    if (!user) return <Navigate to="/login" state={{ from: loc }} replace />;

    // Impersonation strips admin-console access — operator is inside a
    // tenant context and should use the tenant routes.
    if (!user.is_platform_admin || user.impersonated_by) {
        return <Navigate to="/" replace />;
    }

    return children;
}
